import { useLayoutEffect } from "react";

import { Loader } from "@braintrust/braintrust-ui-components";

export const AIInterviewRedirect = () => {
  useLayoutEffect(() => {
    window.location.reload();
  }, []);

  return <Loader centered />;
};
